/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:require('../../../../model/swiper/SwiperItem'),
    method:{
        init:function () {
            // this.onChange('imgUrl',function (inEvent,inUrl) {
            //     return 'url('+inUrl+')';
            // },this,{before:true});
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/banner/ImgItem.js
// module id = 525
// module chunks = 6